import React from 'react';
import '../CampanaInfo/CampanaInfo.css';
function Quorum(props) {
  const {
    estateVotesQuorum1,
    estateVotesQuorum2,
    availableVotesQuorum1,
    availableVotesQuorum2,
    voteNoConfirm,
    redirectTransmision,
    texto,
    idCampana1,
    idCampana2,
    id,
    nombre
    
  } = props;

  return (
    <li className="cards_item" key={id} >
      <div className="card" style={{ backgroundImage: "url(/fondos/Fondo1.jpg)" }}>
        <h2 className="card_title">{nombre}</h2>
        <p className="card_text_qourum card_text">
          {texto}.
        </p>
        <center>
          <div>
            <div
              style={{ backgroundImage: "url(/iconos/icono1.png)" }}
              className={estateVotesQuorum1 === "Allow" && availableVotesQuorum1 > 0 ? "hand-left" : "hand-left visibility-hidden"}
            ></div>
            <div
              style={{ backgroundImage: "url(/iconos/icono1.png)" }}
              className={estateVotesQuorum2 === "Allow" && availableVotesQuorum2 > 0 ? "hand-right" : "hand-right visibility-hidden"}
            ></div>
            <div>
              <div className="hrs-left">Primera</div>
              <div className="hrs-right">Segunda</div>
            </div>
          </div>
          <button
            disabled={estateVotesQuorum1 === "Allow" && availableVotesQuorum1 > 0 ? "" : "disabled"}
            className={estateVotesQuorum1 === "Allow" && availableVotesQuorum1 > 0 ? "button-candidate button-candidate-double" : "button-candidate-disabled button-candidate-double"}
            onClick={e => {
              voteNoConfirm(idCampana1, e);
              redirectTransmision();
            }}
          >
            Presente
          </button>
          <button
            disabled={estateVotesQuorum2 === "Allow" && availableVotesQuorum2 > 0 ? "" : "disabled"}
            className={estateVotesQuorum2 === "Allow" && availableVotesQuorum2 > 0 ? "button-candidate button-candidate-double" : "button-candidate-disabled button-candidate-double"}
            onClick={e => {
              voteNoConfirm(idCampana2, e);
              redirectTransmision();
            }}
          >
            Presente
          </button>
        </center>
      </div>
      </li> 
  );
}

export default Quorum;